import { OptType } from '../../../services/um/lookups/useIRB'
import { GetProjectResultType } from '../../../services/web/types/responseWebServiceTypes'
import useAuthenStore from '../../../stores/authen/authenStore'

const useVerifyDocumentProjectDetail = () => {
    const authenStore = useAuthenStore()

    const createInitialProjectDetail = (projectData: GetProjectResultType | undefined, lutIrb: OptType[]) => {
        let isRequestCertificatePager: string | null = null
        if (typeof projectData?.isRequestCertificatePager === 'boolean') {
            if (projectData?.isRequestCertificatePager === true) {
                isRequestCertificatePager = '1'
            } else {
                isRequestCertificatePager = '2'
            }
        }

        return {
            academicPositionID: projectData?.academicPositionInfo?.value,
            otherAcademicPositionTH: projectData?.academicPositionOther_th,
            otherAcademicPositionEN: projectData?.academicPositionOther_en,
            email: projectData?.email,
            faculty: {
                label: `${projectData?.facultyInfo?.nameTH}`,
                value: `${projectData?.facultyInfo?.value}`,
            },
            fax: projectData?.fax,
            homePhone: projectData?.homePhone,
            irb: projectData?.irb,
            isDraft: projectData?.isDraft,
            mobilePhone: projectData?.mobilePhone,
            projectNameEN: projectData?.projectName_en,
            projectNameTH: projectData?.projectName_th,
            projectSubmitType: {
                label: `${projectData?.submitTypeInfo?.nameTH}`,
                value: `${projectData?.submitTypeInfo?.value}`,
            },
            nameEN: projectData?.researcherName_en,
            nameTH: projectData?.researcherName_th,
            researcherType:
                projectData?.researcherTypeInfo && projectData?.researcherTypeInfo.value
                    ? {
                          label: `${projectData?.researcherTypeInfo?.nameTH}`,
                          value: `${projectData?.researcherTypeInfo?.value}`,
                      }
                    : null,
            educationLevel:
                projectData?.educationLevelInfo && projectData?.educationLevelInfo.value
                    ? {
                          label: `${projectData?.educationLevelInfo?.nameTH}`,
                          value: `${projectData?.educationLevelInfo?.value}`,
                      }
                    : null,
            titleNameID: projectData?.titleNameInfo?.value,
            otherTitleNameTH: projectData?.titleNameOther_th,
            otherTitleNameEN: projectData?.titleNameOther_en,
            isPhase: projectData?.requestPhase ? '2' : '1',
            isTools: projectData?.isTools ? '2' : '1',
            IRB: lutIrb.filter((itm) => parseInt(itm.value) === projectData?.irb)[0] || null,
            titleName: `${projectData?.titleNameInfo?.value}` || null,
            academicPosition: `${projectData?.academicPositionInfo?.value}` || null,
            langTH: projectData?.isLanguageTH ? projectData?.isLanguageTH : false,
            langEN: projectData?.isLanguageEN ? projectData?.isLanguageEN : false,
            isCertificatePaperList: isRequestCertificatePager,
            remarkFromAdmin: projectData?.verifyDocumentRemark || null,
            numPhase: projectData?.requestPhase,
            isDr: projectData?.isDr ? projectData?.isDr : false,
            researchProjectSummaryTH: projectData?.researchProjectSummary_th ?? null,
            researchProjectSummaryEN: projectData?.researchProjectSummary_en ?? null,
            projectAdvisor: projectData?.projectAdvisor ?? null,
            projectAdvisorEmail: projectData?.projectAdvisorEmail ?? null,
            projectAdvisorEmailReserve: projectData?.projectAdvisorEmailReserve ?? null,
            coResearcher: projectData?.coResearcher
                ? projectData?.coResearcher?.map((e) => {
                      return {
                          ...e,
                          otherTitleNameTH: e.otherTitleNameTh ?? null,
                          otherTitleNameEN: e.otherTitleNameEn ?? null,
                          otherAcademicPositionTH: e.otherAcademicPositionTh ?? null,
                          otherAcademicPositionEN: e.otherAcademicPositionEn ?? null,
                          isDr: e.isAcademicPhd ?? null,
                          nameEN: e.nameEn ?? null,
                          nameTH: e.nameTh ?? null,
                          homePhone: e.homePhoneNumber ?? null,
                          mobilePhone: e.phoneNumber ?? null,
                      }
                  })
                : [],
        }
    }

    const updateProjectDetailFormatting = (rawData: any, projectData: GetProjectResultType | undefined) => {
        return {
            projectID: Number(projectData?.projectID),
            submittedID: Number(projectData?.submittedID),
            irb: Number(rawData?.irb),
            researcherUserID: Number(projectData?.researcherUserID),
            userID: Number(authenStore.profile.userId),
            projectName_th: rawData.projectNameTH,
            projectName_en: rawData.projectNameEN,
            projectSubmitTypeID: Number(projectData?.submitTypeInfo?.value),
            facultyID: Number(rawData?.faculty?.value),
            requestPhase: rawData?.numPhase,
            isTools: rawData?.isTools && rawData?.isTools === '2' ? true : false,
            researcherTypeID: Number(rawData?.researcherType?.value),
            titleNameID: rawData?.titleName,
            titleNameOther_th: rawData?.otherTitleNameTH,
            titleNameOther_en: rawData?.otherTitleNameEN,
            isDr: rawData?.isDr,
            academicPositionID: rawData?.academicPosition != 'undefined' ? rawData?.academicPosition : null,
            academicPositionOther_th: rawData?.otherAcademicPositionTH,
            academicPositionOther_en: rawData?.otherAcademicPositionEN,
            educationLevelID: rawData?.educationLevel?.value ? Number(rawData?.educationLevel?.value) : null,
            researcherName_th: rawData?.nameTH,
            researcherName_en: rawData?.nameEN,
            email: rawData?.email,
            homePhone: rawData?.homePhone ?? null,
            mobilePhone: rawData?.mobilePhone,
            fax: rawData?.fax ?? null,
            isLanguage_th: rawData?.langTH ?? false,
            isLanguage_en: rawData?.langEN ?? false,
            isRequestCertificatePaper:
                rawData?.isCertificatePaperList && rawData?.isCertificatePaperList === '1' ? true : false,
            isDraft: rawData?.isDraft ?? false,
            userGroupID: Number(authenStore.profile.userGroupId),
            submitStatusID: Number(projectData?.submittedStatusInfo?.value),
            researchProjectSummary_th: rawData?.researchProjectSummaryTH ?? null,
            researchProjectSummary_en: rawData?.researchProjectSummaryEN ?? null,
            projectAdvisor: rawData?.projectAdvisor ?? null,
            projectAdvisorEmail: rawData?.projectAdvisorEmail ?? null,
            projectAdvisorEmailReserve: rawData?.projectAdvisorEmailReserve ?? null,
            coResearcher: rawData?.coResearcher
                ? rawData?.coResearcher?.map((e: any) => {
                      return {
                          ...e,
                          researcherTypeId: e.researcherType?.value ?? null,
                          nameTh: e.nameTH ?? null,
                          nameEn: e.nameEN ?? null,
                          titleNameId: e.titleName ?? null,
                          otherTitleNameTh: e.titleName?.toString() === '5' ? e.otherTitleNameTH : null,
                          otherTitleNameEn: e.titleName?.toString() === '5' ? e.otherTitleNameEN : null,
                          educationLevelId:
                              e.researcherType?.value?.toString() === '1' ? e.educationLevel?.value : null,
                          isAcademicPhd: e.researcherType?.value?.toString() !== '1' ? e.isDr : null,
                          academicPositionId: e.researcherType?.value?.toString() !== '1' ? e.academicPosition : null,
                          otherAcademicPositionTh:
                              e.researcherType?.value?.toString() !== '1' && e.academicPosition === '6'
                                  ? e.otherAcademicPositionTH
                                  : null,
                          otherAcademicPositionEn:
                              e.researcherType?.value?.toString() !== '1' && e.academicPosition === '6'
                                  ? e.otherAcademicPositionEN
                                  : null,
                          homePhoneNumber: e.homePhone ?? null,
                          phoneNumber: e.mobilePhone ?? null,
                      }
                  })
                : [],
        }
    }

    return {
        createInitialProjectDetail,
        updateProjectDetailFormatting,
    }
}

export default useVerifyDocumentProjectDetail
